// Extra Measurements
export const ExtraValuesFields = [
  { title: "TAPSE", range: "(cm)" },
  { title: "LA Volume Area1", range: "(cm²)" },
  { title: "LA Volume Area2", range: "(cm²)" },
  { title: "LA Volume Length", range: "(mm)" },
  { title: "Height", range: "(cm)" },
  { title: "Weight", range: "(kg)" },
  { title: "BSA", range: "(m²)" },
  { title: "LAVI", range: "(ml/m²)" },

  { title: "LVEDV", range: "(ml)" },
  { title: "LV Mass", range: "(g)" },
  { title: "LV Mass Index", range: "(g/m²)" },
  { title: "PWD", range: "" },
  { title: "RWT", range: "" },
  { title: "Geometry by RWT", range: "" },
];

export default ExtraValuesFields;
